/** Created by azhou on 2019/3/13.*/
<template>
    <div>
      <group-invoice-list v-if="isGroup && !storeId"/>
      <store-invoice-lists v-else/>
    </div>
</template>

<script>
  import { mapGetters } from 'vuex'
  import GroupInvoiceList from './GroupInvoiceList'
  import StoreInvoiceLists from './StoreInvoiceLists'

  export default {
    name: 'GroupInvoiceBus',
    components: { StoreInvoiceLists, GroupInvoiceList },
    computed: {
      ...mapGetters(['storeInfo','isGroup']),
      storeId() { return this.$route.query.store },
    }
  }
</script>
